import axios from "axios";
import { api_url } from "../utils/ApiContext";
import { getAccessToken } from "../utils/tokenStore";

export interface StatisticheData {
  totale_beni: number;
  beni_approvati: number;
  beni_venduti: number;
  beni_valutazione: number;
  valore_totale_vendite: number;
  vendite_mese: number;
  incasso_mese: number;
  nuovi_clienti_mese: number;
  nuovi_contratti_mese: number;
  beni_da_restituire: number;
  contratti_attivi: number;
  trend_vendite_mese: number;
}

export const fetchStatistiche = async () => {
  return axios.get<StatisticheData>(`${api_url}/api/statistiche`, {
    headers: {
      Authorization: `Bearer ${getAccessToken()}`,
    },
  });
};
